
















import { Component, Vue } from 'vue-property-decorator';

import { DateTime } from 'luxon';
import { curPref, Preferences } from '@/services/Preferences';

import Loading from '@/components/Loading.vue';
import VueError from '@/components/VueError.vue';
import NavBar from '@/components/NavBar.vue';
import Users from '@/components/access/Users.vue';
import ApiKeys from '@/components/access/ApiKeys.vue';

@Component({
  components: {
    Loading,
    VueError,
    NavBar,
    Users,
    ApiKeys
  },
})
export default class Access extends Vue {

  curSection:string = curPref.retrieve('v3-access-cur-section', 'users');
  error:string = '';
  
  // our model
  dateTime = DateTime;
  
  async mounted() {
    // nothing to do yet
  }

  navbarClickHandler(newSection:string) {
    curPref.store('v3-access-cur-section', newSection);
    this.curSection = newSection;
  }

}
